import { useEffect, useState } from "react";
import { RulesModel } from "../account/accountApiSlice";
import ButtonWithForm from "../../components/ButtonWithForm";
import ResetPasswordForm from "./ResetPasswordForm";
import { ResetPasswordViewModel, useResetStudentPasswordMutation } from "./usersApiSlice";

interface ButtonProps {
	studentId: number;
	studentName: string;
	rules: RulesModel;
	setResetPasswordError: (message: string) => void;
}

export default function ResetStudentPasswordButton(props: ButtonProps) {
	const [resetModel, setResetModel] = useState<ResetPasswordViewModel>({
		userId: props.studentId,
		password: "",
		confirmPassword: "",
	});
	const [resetPassword, setResetPassword] = useState("");
	const [resetConfirmPassword, setResetConfirmPassword] = useState("");
	const [disableResetPasswordConfirm, setDisableResetPasswordConfirm] = useState(true);

	const [resetStudentPassword] = useResetStudentPasswordMutation();

	useEffect(() => {
		setResetModel({
			...resetModel,
			password: resetPassword,
			confirmPassword: resetConfirmPassword,
		});
	}, [resetPassword, resetConfirmPassword]);

	function handleResetStudentPassword() {
		if (resetModel) {
			resetStudentPassword(resetModel)
				.unwrap()
				.then(() => {
					props.setResetPasswordError("");
				})
				.catch((error) =>
					props.setResetPasswordError(
						error.data
							? `There was an error resetting the password. ${error.data}`
							: "There was an unexpected error while trying to reset the password."
					)
				);
		}
	}

	function updatePassword(password: string) {
		setResetPassword(password);
	}

	function updateConfirmPassword(confirmPassword: string) {
		setResetConfirmPassword(confirmPassword);
	}

	return (
		<ButtonWithForm
			id="reset-password-button"
			className="btn btn-naked border !shadow-md mt-1"
			title={`Reset Password: ${props.studentName}`}
			confirmLabel="Save"
			onConfirm={handleResetStudentPassword}
			disableConfirm={disableResetPasswordConfirm}
			form={
				<ResetPasswordForm
					rules={props.rules}
					isResettingForStudent={true}
					updatePassword={updatePassword}
					updateConfirmPassword={updateConfirmPassword}
					disableConfirm={setDisableResetPasswordConfirm}
				/>
			}>
			Reset Password
		</ButtonWithForm>
	);
}
